/**
 * SummaryItem Component
 * 
 * Individual summary item with icon and text label.
 * Used to display booking details like bay name, date, time, and duration.
 */

import type { SummaryItemProps } from './types';

export function SummaryItem({ 
  icon: Icon, 
  label, 
  srLabel,
  className = '' 
}: SummaryItemProps) {
  return (
    <div 
    className={`flex items-center gap-2 rounded-full bg-theme-25 px-4 py-3 ${className}`}
    >
      <Icon className="h-5 w-5 text-fg-quaternary flex-shrink-0" ariaHidden />
      <span 
      className="text-base text-fg-tertiary"
      data-testid={`booking-summary-item-${srLabel?.toLowerCase()}`}
      >
        {srLabel && <span className="sr-only">{srLabel}: </span>}
        {label}
      </span>
    </div>
  );
}
